import React from 'react'
import { connect } from 'react-redux'

import { shouldTrackGTM } from 'selectors/authSelectors'
import { getGA4Id } from 'selectors/appStatusSelectors'

import { tagCustomer } from 'actions/appStatusActions'

export const bootstrap = (tagCustomer = () => {}) => id => {
  ;(function(w, d, s, l, i) {
    if (typeof window.gtag === 'function') {
      window.gtag({ js: new Date() })
      window.gtag({ config: id })
      window.gtag('get', id, 'client_id', ga4ClientId =>
        tagCustomer(null, null, true, { ga4ClientId }),
      )
    }

    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s)
    j.async = true
    j.id = '__ga4'
    j.src = 'https://www.googletagmanager.com/gtag/js?id=' + i
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', id)
}

export class GA4 extends React.Component {
  componentDidMount() {
    let { shouldTrackGTM, id, tagCustomer } = this.props

    console.info('GA4 Init', id)

    if (id && shouldTrackGTM) {
      bootstrap(tagCustomer)(id)
    }
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  let id = getGA4Id(state)

  return {
    ...op,
    id,
    shouldTrackGTM: shouldTrackGTM(state),
  }
}

export default connect(
  mapStateToProps,
  { tagCustomer },
)(GA4)
